import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20flowing%20golden%20and%20cream%20gradients%2C%20soft%20geometric%20shapes%2C%20elegant%20minimalist%20aesthetic%2C%20Japanese%20Korean%20design%20fusion%2C%20warm%20atmosphere%2C%20professional%20streaming%20platform%20style&width=1920&height=800&seq=cta-bg-2024&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-4">
          准备好开始您的aaa日韩之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 md:mb-10 leading-relaxed">
          立即加入aaa日韩，畅享海量正版日韩资源，高清流畅、多端同步，每日更新不间断
        </p>
        <Link
          to="/about"
          className="inline-flex px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
        >
          立即免费体验
        </Link>
      </div>
    </section>
  );
}